import { render, staticRenderFns } from "./OfferView.vue?vue&type=template&id=561cda40&scoped=true"
import script from "./OfferView.vue?vue&type=script&lang=js"
export * from "./OfferView.vue?vue&type=script&lang=js"
import style0 from "./OfferView.vue?vue&type=style&index=0&id=561cda40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561cda40",
  null
  
)

export default component.exports